<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened"
               class="hamburger-container"
               @toggleClick="toggleSideBar" />
    <div class="navbar__title ui-color--primary ui-font--bold">{{$t('head.title')}}</div>
    <div class="right-menu">
      <div class="user-info">
        <img :src="avatarUrl" class="user-info__avatar" />
        <span class="ui-link ui-font--bold ui-font--mini">{{ userInfo.name }}-{{userInfo.orgName}}{{userInfo.posName}}</span>
        <div class="user-action">

          <el-button class="user-action--report"
                     style="background-color: #486DD5;"
                     type="primary"
                     size="mini"
                     @click="reportHandle">{{$t('head.staffReport')}}</el-button>
          <el-popover placement="bottom"
                      :title="$t('head.messageList')"
                      width="400"
                      trigger="manual"
                      :style="{position: 'relative'}"
                      v-model="visible">
            <div slot="reference"
                 @click="toggleMessageList"
                 class="message"
                 :class="{'message--new': messageList.length > 0}">
              <div class="message--new__count"
                   v-show="messageList.length > 0">{{messageList.length | converMessageCount}}</div>
              <img src="~@/assets/images/head_icon_quit_nor@2x.png" />
              <div class="ui-link">{{$t('head.message')}}</div>
            </div>
            <div class="ui-align--center">
              <div class="message-list" v-if="messageList.length > 0">
                <el-card shadow="hover"
                         :body-style="{padding: '5px'}"
                         v-for="(message, index) in messageList"
                         :key="index"
                         class="message-list__item">
                  <div slot="header" class="ui-layout-flex">
                    <div class="header__title ui-flex--1 ui-text-overflow--ellipsis ui-font--bold">{{message.title}}</div>
                    <a class="ui-link header__action"
                       @click="setMessageRead(message)">[{{$t('head.setRead')}}]</a>
                  </div>
                  <div v-html="message.content"></div>
                  <div class="ui-align--right ui-font--mini"
                       :style="{color: 'red'}">{{message.sendTime}}</div>
                </el-card>
              </div>
              <div v-else class="ui-layout-flex" :style="{height: '200px'}">
                <span :style="{margin: 'auto', color: '#909399'}">{{$t('common.noData')}}</span>
              </div>
              <div class="popover-title__action">
                <i class="el-icon-close ui-link" @click="toggleMessageList"></i>
              </div>
              <el-button type="primary"
                         v-show="!allMessageRead"
                         @click="setAllMessageRead">{{$t('head.setAllRead')}}</el-button>
            </div>
          </el-popover>

          <div @click="goSso" class="sso">
            <img src="~@/assets/images/head_icon_application_nor@2x.png" />
            <div class="ui-link">{{$t('head.sso')}}</div>
          </div>
          <div @click="doLogout" class="logout">
            <img src="~@/assets/images/head_icon_logout_nor@2x.png" />
            <div class="ui-link">{{$t('head.logout')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '@/components/Breadcrumb';
  import Hamburger from '@/components/Hamburger';
  import {mapGetters} from 'vuex';
  export default {
      components: {
          Breadcrumb,
          Hamburger
      },
      data() {
          return {
              avatarUrl: '',
              visible: false,
              messageList: [],
              SSOUrl: '',
              ReportUrl: '',
              // 多语言
              i18nValues: [
                  {label: '简体中文', menuLable: '简', value: 'zh-CN'},
                  {label: 'English', menuLable: 'EN', value: 'en-US'}
              ],
              userPlaces: [],
              currentPlaceId: ''
          };
      },
      computed: {
          ...mapGetters(['sidebar', 'avatar', 'userInfo', 'language']),
          i18nValue: {
              get() {
                  return this.language;
              },
              set(val) {
                  this.$i18n.locale = val;
                  Cookies.set('language', val);
                  this.$store.commit('app/SET_LANGUAGE', val);
              }
          },
          allMessageRead() {
              return this.messageList.length === 0;
          },
          device() {
              return this.$store.state.app.device;
          },
          userPicUrl() {
              return localStorage.getItem('userPicUrl') || '~@/assets/images/head_icon_accout_nor@2x.png';
          }
      },
      filters: {
          converMessageCount(val) {
              if (val > 99) {
                  return '99+';
              }
              return val;
          },
          convertLanguageLabel(val) {
              if (val === 'zh-CN') {
                  return 'English';
              }
              return '简体中文';
          }
      },
      methods: {
          setAllMessageRead() {
              const messageList = this.messageList;
              if (messageList.length === 0) {
                  return;
              }
              this.$client.readMessage(messageList.map(item => item.messageId)).then(() => {
                  this.messageList = [];
              });
          },
          setMessageRead(message) {
              const {messageId} = message;
              this.$client.readMessage([messageId]).then(() => {
                  for (let i = 0, len = this.messageList.length; i < len; i++) {
                      if (this.messageList[i].messageId === messageId) {
                          this.messageList.splice(i, 1);
                      }
                  }
              });
          },
          toggleMessageList() {
              this.visible = !this.visible;
          },
          dropdownClickHandle(command) {
              const mappindg = {
                  language: this.languageHandle,
                  report: this.reportHandle,
                  logout: this.doLogout,
                  sso: this.goSso
              };
              const fn = mappindg[command];
              fn && fn();
          },
          languageHandle() {
              const language = this.i18nValue === 'zh-CN' ? 'en-US' : 'zh-CN';
              const locale = language === 'zh-CN' ? 'zh_CN' : 'en_US';
              Cookies.set('language', language);
              this.$i18n.locale = language;
              this.$store.commit('app/SET_LANGUAGE', language);
          },
          goSso() {
              //window.location.href = this.SSOUrl;
              window.open(this.SSOUrl);
          },
          getSSOAndReportUrl() {
              this.$client.getHomeConfig().then(data => {
                  this.SSOUrl = data.data.sso;
                  this.ReportUrl = data.data.viewStaffReportIm;
              });
          },
          reportHandle() {
              window.open(this.ReportUrl);
          },
          doLogout() {
              this.$store.commit('SET_TOKEN', '');
              window.location.href = '/api/v1/appserver/user/logout';
          },
          toggleSideBar() {
              this.$store.dispatch('toggleSideBar');
              //触发onresize事件，exSearchForm组件重新计算
              if (document.createEvent) {
                  var event = document.createEvent('HTMLEvents');
                  event.initEvent('resize', true, true);
                  window.dispatchEvent(event);
              } else if (document.createEventObject) {
                  window.fireEvent('onresize');
              }
          },
          getUserPicUrl() {
              this.$client.getUserPicUrl(this.userInfo.id).then(ret => {
                  this.avatarUrl = ret.data;
              });
          },

          currentPlaceChange(placeId) {
              this.$store.dispatch('changePlace', placeId);
              window.localStorage.setItem('currentPlaceId', placeId);//写入到localStorage，方便在下一次登录时自动切换成上一次的当前站点
          }
      },
      created() {
          this.getUserPicUrl();
          this.getSSOAndReportUrl();
      }
  };
</script>

<style lang="less" scoped>
  .navbar {
    display: flex;
    height: 45px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    &__title

  {
    margin: auto 15px;
    font-size: 18px;
    word-spacing: 3px;
  }

  .right-menu {
    margin-left: auto;
    height: 100%;
    margin-right: 10px;
    cursor: pointer;
    display: flex;
    .el-dropdown{display: flex;}

  .user-info {
    display: flex;
    align-items: center;
    margin-right: 10px;
    &__avatar{
    height: 40px;
    width: auto;
    border-radius: 50%;
    margin-right: 10px;
  }

  &__username {
    font-weight: 600;
    font-size: 12px;
    margin-right: 15px;
  }

  }

  .user-action {
    display: flex;
    &--language, &--report

  {
    margin: auto 10px;
  }

  }

  .sso,
  .logout,
  .message {
    font-size: 12px;
    text-align: center;
    margin: auto 10px;
    position: relative;
    & > img

  {
    height: 18px;
  }

  }

  .message--new {
    &__count

  {
    color: white;
    min-width: 14px;
    height: 14px;
    display: inline-block;
    padding: 1px;
    line-height: 1;
    background: red;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 99;
    animation: msg steps(6, start) 2000ms infinite normal backwards;
    transform: translateX(50%);
  }

  }
  }
  }

  /deep/ .el-dropdown-menu__item {
    min-width: 195px;
  }

  .message-list {
    max-height: calc(100vh - 200px);
    overflow: auto;
    &__item

  {
    margin-bottom: 5px;
    .header__title

  {
    white-space: nowrap;
    margin-right: auto;
  }

  .header__action {
    flex-shrink: 0;
  }

  }
  }

  .popover-title__action {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  @keyframes msg {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
</style>
